var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[(_vm.item)?_c('span',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.item)))]):_c('span',[_vm._v("Page")]),_vm._v(" not found. ")])}
var staticRenderFns = []

export { render, staticRenderFns }